import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";



export const linkedinSchema = z.object({
    url: z.string(),
})

export class LinkedInDto extends createZodDto(linkedinSchema) {}